export default __webpack_public_path__ + "static/bts-f97e99cdaee5b723cc9c169c0e8336cc.mp4";